class HelpController {
    constructor(
		private ModalService
	) {}
	
	public onOpenSupportModal() {
	    this.ModalService.showModal({
			component: 'supportTicketModal',
			bodyClass: 'angular-modal-service-active',
			bindings: { },
			preClose: (modal) => {
				modal.element.modal('hide');
			}
		})
		.then((modal) => {
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
}

export { HelpController };